import React, { useState } from "react";
import { useLocation } from "@reach/router";
import { useForm } from "react-hook-form";
import Loader from "components/loader";
import { useGetInTouchLocation } from "hooks/Forms/useGetInTouchLocation";
import ThankYouPopup from "components/popup/thankYouPopup";
import Badge from "assets/images/new-homepage-assets/desktop/badge.svg";
import Group from "assets/images/new-homepage-assets/desktop/Group.svg";
import CallCenter from "assets/images/new-homepage-assets/desktop/call-center.svg";
import { data } from "../../../queries/translatorHub";
import formCommonPostData from "utils/form-common-post-data";

const BannerSingleLang = Data => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const { status, mutateAsync } = useGetInTouchLocation();

  const onSubmit = data => {
    const postData1 = {
      name: data.name,
      email: data.email,
      message: data.message,
      pagelink: location.href
    };
    const postData = { ...postData1, ...formCommonPostData() };
    mutateAsync(postData).then(_ => {
      reset();
      setOpen(true);
    });
  };

  return (
    <div>
      <div className=" bg-DynamicLang bg-no-repeat bg-cover pt-6">
        {/* -----First Component----- */}
        <div className="flex flex-col lg:flex-row gap-6 xl:gap-0 w-full px-3 sm:px-0 sm:w-11/12 xl:w-10/12 2xl:w-9/12 max-w-7xl mx-auto justify-between items-start 2xl:max-w-6xl">
          <div className="flex flex-col sm:w-[614px] sm:pt-8">
            <h1
              className="text-[35px] sm:px-0 sm:text-[40px] font-bold font-secondary text-[#00173A]"
              dangerouslySetInnerHTML={{
                __html: Data.data.title_block_1
              }}
            />

            <div
              className="text-[18px] leading-loose text-[#00173A] font-sans py-4"
              dangerouslySetInnerHTML={{
                __html: Data.data.description_block_1
              }}
            />
            <a
              className="text-[18px] font-semibold items-center bg-[#ff7b16] text-white flex justify-center mt-6 hover:bg-[#ff9a16]"
              href="/quote"
              style="top: 451px; left: 100px; width: 250px; height: 50px;  0% 0% no-repeat padding-box;box-shadow: 0px 3px 6px #00000029; border-radius: 30px; opacity: 1;"
            >
              TRANSLATE NOW
            </a>
          </div>
          <ThankYouPopup open={open} setOpen={setOpen} />

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="h-full px-6 sm:px-8 pt-6 sm:pt-8 w-[347px] sm:w-[417px] bg-[#FFFFFF] pb-6 sm:pb-8 mt-[3rem] sm:mt-[1rem]"
            style="box-shadow: 5px 5px 50px #004C7430; border-radius: 8px;"
          >
            <div className="text-[18px] sm:text-[35px] font-semibold font-secondary">
              <span className="text-orange">Get in touch</span>
            </div>

            {/* <div
              className="text-[15px] font-sans py-3"
              dangerouslySetInnerHTML={{
                __html: Data.data.meta_description,
              }}
            /> */}
            <div className="flex flex-col">
              <input
                type="text"
                name="name"
                className="pl-2 py-2 rounded mt-2"
                placeholder="Name"
                style="border: 1px solid #D8D8D8;"
                {...register("name", {
                  required: true
                })}
              />
              {errors.name && <span className="text-red text-sm mb-[10px] font-sans mt-2">This field is required.</span>}

              <input
                type="text"
                placeholder="Email"
                name="email"
                className="pl-2 py-2 rounded mt-2"
                style="border: 1px solid #D8D8D8;"
                {...register("email", {
                  required: true
                })}
              />
              {errors.email && <span className="text-red text-sm font-sans mb-[10px] mt-2">This field is required.</span>}

              <textarea
                type="text"
                name="message"
                className="pl-2 py-2 rounded mt-2 min-h-[96px]"
                placeholder="Tell us more about your needs"
                style="border: 1px solid #D8D8D8;"
                {...register("message")}
              />
              {errors.message && <span className="text-red text-sm font-primary mb-[10px] ">This field is required</span>}

              <button className="bg-orange text-white text-[18px] font-sans py-3 mt-4">
                {status === "loading" ? <Loader /> : "SUBMIT"}
              </button>
            </div>
          </form>
        </div>
        <ul className="flex lg:flex-row flex-col text-white sm:justify-between lg:mx-auto  xl:justify-evenly  gap-x-10 lg:gap-y-0 gap-y-8 pb-12 pt-4 sm:ml-0 ml-4 2xl:w-[70%]">
          <li className="flex items-center">
            <img src={CallCenter} alt={CallCenter} className="w-[30px] lg:w-[40px]" />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">Available Online 24/7</p>
          </li>
          <li className="flex items-center">
            <img src={Badge} alt={Badge} className="w-[30px] lg:w-[40px]" />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">1-Year Guarantee</p>
          </li>
          <li className="flex items-center">
            <img src={Group} alt={Group} className="w-[30px] lg:w-[40px]" />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">95,000 Business Customers</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BannerSingleLang;
